import { defaultHttpClient } from 'shared/src/api/httpClient';

export type EditLikedFoldersOrderParams = {
  folder_snos: number[];
};

export const editLikedFoldersOrder = async ({
  folder_snos,
}: EditLikedFoldersOrderParams) => {
  return defaultHttpClient.request<void>({
    method: 'PUT',
    url: '/api/v2/members/me/liked_folders/sequence/',
    data: { folder_snos },
  });
};
